/*
    How each column is calculated (MPN-1688, restyled for MPN-2044).

    Collapsed by default and on the Overview, where somebody who has just read a tile they do
    not believe is standing. The Google Sheet this replaces showed its formulas in the cells;
    hiding them behind a rewrite would be a step backwards, so they are here in full.

    The heading says "How Each Column Is Calculated" rather than "How these figures are
    calculated". "These figures" pointed at nothing in particular from the bottom of a page of
    tables; "each column" says what is in the drawer, which is the one thing a collapsed
    section has to get right. The count pill says how many definitions are behind it, so the
    cost of opening it is visible before it is paid.

    The same entries render in the popover behind each column heading. One source, because two
    copies of this text would drift and the drifted one is what ends up in a board deck.
*/
import { ChevronDown, ChevronRight } from "lucide-react";
import { useState } from "react";

import { METHODOLOGY, type MethodEntry } from "./methodology";

export function MethodBody({ entry }: { entry: MethodEntry }) {
    return (
        <>
            {entry.values && (
                <dl className="holdout-report__method-values">
                    {entry.values.map((value) => (
                        <div key={value.name}>
                            <dt>{value.name}</dt>
                            <dd>{value.means}</dd>
                        </div>
                    ))}
                </dl>
            )}
            <p className="holdout-report__method-text">{entry.body}</p>
        </>
    );
}

export default function MethodologyPanel() {
    const [open, setOpen] = useState(false);
    const Chevron = open ? ChevronDown : ChevronRight;

    return (
        <section className="holdout-report__method">
            <button type="button" className="holdout-report__method-toggle"
                aria-expanded={open}
                onClick={() => setOpen(!open)}>
                <Chevron size={15} aria-hidden="true" />
                <h2>How Each Column Is Calculated</h2>
                <span className="holdout-report__count">{METHODOLOGY.length}</span>
                <span className="holdout-report__method-hint">
                    {open ? "Hide" : "Show"}
                </span>
            </button>
            {open && (
                <div className="holdout-report__method-body">
                    {METHODOLOGY.map((entry) => (
                        <div key={entry.field} className="holdout-report__method-entry">
                            <div className="holdout-report__method-field">{entry.field}</div>
                            <MethodBody entry={entry} />
                        </div>
                    ))}
                </div>
            )}
        </section>
    );
}
